export default __webpack_public_path__ + "static/media/bandhavgarh.eab4cc95.jpg";